import { render, staticRenderFns } from "./DocumentsTabContent.vue?vue&type=template&id=7bbe67d3&"
import script from "./DocumentsTabContent.vue?vue&type=script&lang=ts&"
export * from "./DocumentsTabContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports